export const apiEndpoints = {
  // Auth endpoints
  auth: {
    login: () => '/oauth2/authorize',
    token: () => '/oauth2/token',
    logout: () => '/oauth2/logout',
    userInfo: () => '/oauth2/userinfo',
    refreshToken: () => '/oauth2/token'
  },
  
  // Customer endpoints (Order Management API)
  customers: {
    root: () => '/customers',
    get: (id: string) => `/customers/${id}`,
    profile: (id: string) => `/customers/${id}/profile`,
    updateProfile: (id: string) => `/customers/${id}/profile`,
    addresses: (customerId: string) => `/customers/${customerId}/addresses`,
    address: (customerId: string, addressId: string) => `/customers/${customerId}/addresses/${addressId}`
  },
  
  // User endpoints
  users: {
    me: () => '/users/me',
    profile: () => '/users/profile',
    get: (id: string) => `/users/${id}`,
    updateProfile: () => '/users/profile',
    orders: (userId: string) => `/users/${userId}/orders`,
    addresses: (userId: string) => `/users/${userId}/addresses`
  },
  
  // Product endpoints
  products: {
    list: () => '/products',
    get: (id: string) => `/products/${id}`,
    getByProductCode: (productCode: string) => `/products/code/${productCode}`,
    create: () => '/products',
    update: (id: string) => `/products/${id}`,
    delete: (id: string) => `/products/${id}`,
    variants: (id: string) => `/products/${id}/variants`,
    images: (id: string) => `/products/${id}/images`
  },
  
  // Category endpoints
  categories: {
    list: () => '/categories',
    products: (category: string) => `/categories/${category}/products`
  },
  
  // Order endpoints
  orders: {
    list: () => '/orders',
    get: (id: string) => `/orders/${id}`,
    create: () => '/orders',
    updateStatus: (id: string) => `/orders/${id}/status`
  },
  
  // Cart endpoints
  cart: {
    get: () => '/cart',
    addItem: () => '/cart/items',
    updateItem: (id: string) => `/cart/items/${id}`,
    removeItem: (id: string) => `/cart/items/${id}`,
    clear: () => '/cart/clear'
  },
  
  // Payment endpoints
  payments: {
    get: (id: string) => `/payments/${id}`,
    getByOrder: (orderId: string) => `/payments/order/${orderId}`,
    createIntent: () => '/payments/intent',
    process: (id: string) => `/payments/${id}/process`
  },
  
  // Refund endpoints
  refunds: {
    get: (id: string) => `/refunds/${id}`,
    create: () => '/refunds'
  },
  
  // Support ticket endpoints
  tickets: {
    list: () => '/support/tickets',
    get: (id: string) => `/support/tickets/${id}`,
    create: () => '/support/tickets',
    update: (id: string) => `/support/tickets/${id}`,
    comments: (id: string) => `/support/tickets/${id}/comments`
  },
  
  // Search endpoints
  search: {
    products: () => '/search',
    suggestions: () => '/search/suggestions',
    trending: () => '/search/trending'
  },
  
  // Inventory endpoints
  inventory: {
    get: (productId: string) => `/inventory/${productId}`
  },
  
  // Checkout endpoints
  checkout: {
    calculate: () => '/checkout/calculate'
  },
  
  // Configuration endpoints
  configurations: {
    list: () => '/configurations',
    get: (key: string) => `/configurations/${key}`,
    update: (key: string) => `/configurations/${key}`
  }
}
